function renderCharts(customSelector) {

	let selector = customSelector || ".apexchart--caramella";
	let defaultOptions = {
		series: [44, 55, 13, 43, 22],
		chart: {
			width: 380,
			type: 'pie'
		},
		labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
		responsive: [{
			breakpoint: 480,
			options: {
				chart: {
					width: 200
				},
				legend: {
					position: 'bottom'
				}
			}
		}]
	};
	if (typeof ApexCharts !== 'undefined') {
		jQuery(selector).each(function (i, chart) {
			let $this = jQuery(this);

			if ($this.data('chart-initialized')) return;
			let customOptions = $this.data('options');
			let mergedOptions = Object.assign({}, defaultOptions, customOptions);
			let apexchart = new ApexCharts(chart, mergedOptions);
			apexchart.render();
			$this.data('chart-initialized', true);
		});
	} else {
		console.warn("ApexCharts is not loaded so we are skipping it.");
	}
}

window.caramellaSafeExecute(renderCharts);
